import { createContext, useState } from "react";

import ApiService from "../_services/ApiService";

export const LessonPlanContext = createContext({
  getAllLessonPlans: () => {},
  getLessonPlanById: () => {},
  getLessonSteps: ()=>{}
});

export const LessonPlanProvider = ({ children }) => {
  const [lessonPlans, setLessonPlans] = useState({
    lessons: [],
    error: null,
  });

  const [lessonSteps, setLessonSteps] = useState({});

  const fetchLessonPlans = async (typeId, subTypeId) => {
    let lessonPlanValue = {};

    try {
      const lessonPlansData = await ApiService.fetchLearning(typeId, subTypeId);

      if (lessonPlansData.data.length) {
        lessonPlanValue = {
          lessons: lessonPlansData.data,
          error: null,
        };
      }
    } catch (error) {
      console.log(error);

      lessonPlanValue = {
        lessons: [],
        error,
      };
    }

    setLessonPlans(lessonPlanValue);
    return lessonPlanValue;
  };

  const getAllLessonPlans = async (typeId, subTypeId) => {
    if (lessonPlans.lessons.length) {
      return lessonPlans.lessons;
    }

    const { lessons, error } = await fetchLessonPlans(typeId, subTypeId);

    if (error) return [];

    return lessons;
  };

  const getLessonPlanById = async (typeId, subTypeId, lessonPlanId) => {

    console.log(typeId, subTypeId, "get");

    if(typeId === undefined || subTypeId === undefined) return {};

    let fetchedLessons = lessonPlans.lessons;

    if (!fetchedLessons.length) {
      const { lessons, error } = await fetchLessonPlans(typeId, subTypeId);

      if (error) return {};

      fetchedLessons = lessons;
    }

    const requiredLessonPLan = fetchedLessons.find(
      (lesson) => lesson.id.toString() === lessonPlanId.toString()
    );

    if (!requiredLessonPLan) return {};

    return requiredLessonPLan;
  };

  const getLessonSteps = async (learnId) => {
    if (lessonSteps[learnId]?.steps?.groups?.length) {
      return lessonSteps[learnId]?.steps;
    }

    const lessonStep = {
      steps: {
        groups: [],
        name: ""
      },
      error: null,
    };

    try {
      const lessonStepsData = await ApiService.fetchLearningStepsDesktop(
        learnId
      );

      lessonStep.steps = lessonStepsData.data;
    } catch (error) {
      console.log(error);
      lessonStep.error = error;
    }

    setLessonSteps({
      ...lessonSteps,
      [learnId]: lessonStep,
    });

    return lessonStep.steps;
  };

  const value = {
    getAllLessonPlans,
    getLessonPlanById,
    getLessonSteps
  };

  return (
    <LessonPlanContext.Provider value={value}>
      {children}
    </LessonPlanContext.Provider>
  );
};
